/**
 * appMode.ts — Source unique de vérité pour APP_MODE
 *
 * Lit window.__APP_MODE__ au RUNTIME (pas à la compilation).
 * Injecté par legalgraph_app.py en prod, ou via index.html en dev.
 */
export function getAppMode(): string {
  return (window as any).__APP_MODE__ || 'legalchat';
}

export function isLegalGraph(): boolean {
  return getAppMode() === 'legalgraph';
}

/** Hôtes du back-office master (même règle que useAppContext). */
const MASTER_HOSTS = ['legalchat.smartlawyer.ai', 'localhost'];

/**
 * Console d'administration : legalchat sur l'hôte master. Ni chat, ni pages
 * publiques, ni socket : seul le back-office est servi.
 */
export function isAdminConsole(): boolean {
  return (
    getAppMode() === 'legalchat' &&
    MASTER_HOSTS.includes(window.location.hostname)
  );
}

/** Chemins servis par la console ; tout le reste renvoie vers /admin. */
export const ADMIN_CONSOLE_PATHS = [
  '/admin',
  '/login',
  '/forgot-password',
  '/reset-password',
  '/change-password',
  '/profile'
];

export function isAdminConsolePath(pathname: string): boolean {
  return ADMIN_CONSOLE_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
}

/**
 * SmartLawyer Desktop (app Electron) : la fenêtre charge smartlawyer.ai avec un
 * user-agent « SmartLawyerDesktop » et, sur ce seul domaine, expose window.sl
 * (Ollama local, dossiers clients). Mode produit : recherche, fiches, agents —
 * sans pages marketing.
 */
export function isDesktop(): boolean {
  return /SmartLawyerDesktop\//.test(navigator.userAgent) || Boolean((window as any).sl?.desktop);
}

/** Pont local exposé par l'app desktop (Ollama, dossiers) — null hors desktop. */
export function desktopBridge(): any | null {
  return isDesktop() ? (window as any).sl ?? null : null;
}
